angular.module("templates")

    .controller("TemplatesEditCtrl", ['LanguagesService', 'LoginService', '$scope', '$rootScope', '$state', '$stateParams', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal', 'BeeService', 'logService',
        function (LanguagesService, LoginService, $scope, $rootScope, $state, $stateParams, Restangular, gridService, $filter, $translate, modalService, $uibModal, BeeService, logService) {

            //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("TEMPLATES_WRITE");

            $rootScope.title = $filter('translate')('templates.title');

            $scope.tinymceOptions = {
                resize: true,
                //forced_root_block: false,
                contextmenu: false,
                branding: false,

                relative_urls: false,
                convert_urls: false,
                remove_script_host: false,

                height: "600",
                body_class: 'custom_tinymce_content',
                //valid_classes: 'razor_expression',
                language: 'es',
                paste_as_text: true,
                plugins: 'paste autoresize textcolor image lists advlist table noneditable code link fullpage',
                toolbar: "undo redo | alignleft aligncenter alignright alignjustify | bold italic forecolor backcolor fontsizeselect | bullist numlist outdent indent link | table | image | code",
                menubar: false,
                statusbar: false,
                setup: function (editor) {
                }
            };

            $scope.template = {
                FK_templates_tl_templates: []
            };
            
            $scope.loadBee = false;

            if(!$scope.loadBee) {
                LanguagesService.languages().then(function (languages) {
                    angular.forEach(languages, function (language) {
                        let tl = $scope.template.FK_templates_tl_templates.filter(tl => tl.language_id === language.id);
                        if(tl === null || tl === undefined) {
                            $scope.template.FK_templates_tl_templates.push({language_id: language.id, html: "<html><body></body></html>"});
                        }
                    });
                });
            }

            if (angular.isUndefined($stateParams.id) || $stateParams.id == "") {

                $rootScope.breadcrumb = [
                    {title: $filter('translate')('templates.title'), url: "templates.list"},
                    {title: $filter('translate')('templates.title_add')},
                ];
                
                $scope.loadBee = true;
                BeeService.start({});
            } else {
                $rootScope.breadcrumb = [
                    {title: $filter('translate')('templates.title'), url: "templates.list"},
                    {title: $filter('translate')('templates.title_edit')},
                ];

                Restangular.one('Templates', $stateParams.id).get().then(function (result) {
                    $scope.template = result;
                    logService.debug($scope.template.FK_templates_tl_templates);
                    if($scope.template.FK_templates_tl_templates[0].json != null && $scope.template.FK_templates_tl_templates[0].json != "") {
                        $scope.loadBee = true;
                        BeeService.start(JSON.parse($scope.template.FK_templates_tl_templates[0].json));
                    }
                });
            }

            $scope.saveTemplate = function () {
                if($scope.loadBee) {
                    BeeService.save().then(function (result) {
                        LanguagesService.languages().then(function (languages) {
                            angular.forEach(languages, function (language) {
                                let tl = $scope.template.FK_templates_tl_templates.filter(tl => tl.language_id === language.id);
                                if(tl === null || tl === undefined || tl.length === 0) {
                                    let tl = {
                                        language_id: language.id,
                                        html: result.html,
                                        json: result.json
                                    };
                                    $scope.template.FK_templates_tl_templates.push(tl);
                                } else {
                                    logService.debug(tl);
                                    tl[0].html = result.html;
                                    tl[0].json = result.json;
                                }
                            });
                            $scope.saveOrUpdate();
                        });
                    });
                } else {
                    $scope.saveOrUpdate();
                }
            };

            $scope.saveOrUpdate = function() {
                if (angular.isDefined($stateParams.id) && $stateParams.id != "") {
                    $scope.template.put().then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('templates.save_success'));
                            $state.go("templates.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                } else {
                    Restangular.all('Templates').post($scope.template).then(function (result) {
                        if (angular.isDefined(result.id)) {
                            toastr.success($filter('translate')('templates.edit_success'));
                            $state.go("templates.list");
                        } else {
                            $scope.errorMessage = result.message;
                        }
                    });
                }                
            }
            
            $scope.checkDelete = function () {
                modalService.confirm({
                    title: $filter('translate')('templates.button_delete'),
                    message: $filter('translate')('templates.delete_message') + " " + $scope.template.name + "?",
                    onAccept: function () {
                        $scope.template.remove().then(function () {
                            toastr.success($filter('translate')('templates.deleted_success'));
                            $state.go("templates.list");
                        });
                    }
                });
            };
            
            $scope.copyToClipboard = function () {
                BeeService.save().then(function (result) {
                    var copyElement = document.createElement("textarea");
                    copyElement.style.position = 'fixed';
                    copyElement.style.opacity = '0';
                    copyElement.textContent = result.json;
                    var body = document.getElementsByTagName('body')[0];
                    body.appendChild(copyElement);
                    copyElement.select();
                    document.execCommand('copy');
                    body.removeChild(copyElement);
                });
            };

            $scope.readFromClipboard = function () {
                navigator.clipboard.readText().then(text => {
                    BeeService.reload(JSON.parse(text));
                });
            };


        }])
;

